// IANA time zones for the owner's time-zone picker (setup and Settings). Pure, so tests pin them.

/** Every zone this browser knows, plus `current` and UTC, in alphabetical order. */
export function timeZoneOptions(current: string | null | undefined): string[] {
  let known: string[] = [];
  try {
    known = Intl.supportedValuesOf("timeZone");
  } catch {
    // Older browsers: the picker still offers the current zone and UTC.
  }
  const all = new Set([...known, "UTC", ...(current ? [current] : [])]);
  return [...all].sort((a, b) => a.localeCompare(b));
}

/** "America/New_York" → "America / New York". */
export function zoneLabel(zone: string): string {
  return zone.replaceAll("_", " ").replaceAll("/", " / ");
}

/** The clock in `zone` right now, e.g. "9:05 AM", so the owner can check it's the right one. */
export function clockIn(zone: string, now: number | Date, locale?: string): string {
  try {
    return new Intl.DateTimeFormat(locale, {
      hour: "numeric",
      minute: "2-digit",
      timeZone: zone,
    }).format(now);
  } catch {
    return "";
  }
}
